module.exports = __webpack_public_path__ + "media/public/img/logo-tourism-tribe-5b5c87a9f88d80e2b6b5588b6b0c7699.png";